import { LabelMapper, VatRateType } from 'types';
import { settingsTexts } from 'consts/text';

export const settlementVatRateTypeLabels: LabelMapper<VatRateType> = {
    [VatRateType.VAT_0]: settingsTexts.settlements.vatRates.vatRateLabels.vat0,
    [VatRateType.VAT_5]: settingsTexts.settlements.vatRates.vatRateLabels.vat5,
    [VatRateType.VAT_8]: settingsTexts.settlements.vatRates.vatRateLabels.vat8,
    [VatRateType.VAT_23]: settingsTexts.settlements.vatRates.vatRateLabels.vat23,
    [VatRateType.NOT_SUBJECT]: settingsTexts.settlements.vatRates.vatRateLabels.notSubject,
    [VatRateType.RELEASED]: settingsTexts.settlements.vatRates.vatRateLabels.released,
};
